// seoData.js — unique title + description for every route.
// Key = path with no trailing slash (homepage = ""). City pages (/wifi-service-provider/:city)
// keep their own title/description from CityBroadband.js.
const SEO = {
  "": {
    title: "Netplus Broadband | Fiber Broadband, IPTV & OTT in Punjab",
    description:
      "Netplus Broadband offers high-speed fiber internet, IPTV and OTT entertainment across Punjab and North India. Explore plans and get a new connection.",
  },
  "/broadband-plans": {
    title: "Broadband Plans in Punjab | Netplus Fiber Internet",
    description:
      "Compare Netplus fiber broadband plans for home use. Pick the speed that suits your household and apply online for a new connection.",
  },
  "/ip-tv": {
    title: "IPTV Plans with Broadband | Netplus Broadband",
    description:
      "Watch live TV over fiber with Netplus IPTV. Explore IPTV plans bundled with broadband and choose the one that fits your family.",
  },
  "/2ip-tv": {
    title: "Netplus IPTV Plans: Second TV Connection",
    description:
      "See Netplus IPTV plans for a second TV in your home and add more entertainment to your broadband connection.",
  },
  "/entertainment-plans": {
    title: "Entertainment Plans: Broadband + OTT | Netplus",
    description:
      "Combine fiber broadband with OTT apps and TV in one Netplus entertainment plan. Compare plans and apply online.",
  },
  "/ott-plans": {
    title: "OTT Plans | Streaming Apps with Netplus Broadband",
    description:
      "Get popular OTT apps with your Netplus broadband connection. See the OTT plans available and choose the one for your household.",
  },
  "/netplus-hd-bundle": {
    title: "Netplus HD Bundle | Broadband and HD Entertainment",
    description:
      "Explore the Netplus HD bundle that brings broadband and HD entertainment together in one connection.",
  },
  "/ip-box": {
    title: "Netplus IP Box | Set-Top Box for IPTV and OTT",
    description:
      "The Netplus IP box brings live TV and OTT apps to your television over your broadband connection.",
  },
  "/retail": {
    title: "Netplus Broadband Connection | Plans for Homes",
    description:
      "See Netplus fiber broadband plans for homes and apply for a new connection from your local Netplus partner.",
  },
  "/about-netplus": {
    title: "About Netplus Broadband | Fiber ISP in North India",
    description:
      "Learn about Netplus Broadband, a Jujhar Group company providing fiber broadband, IPTV and OTT services in Punjab and across North India.",
  },
  "/jujhar-group": {
    title: "Jujhar Group | Parent Company of Netplus Broadband",
    description:
      "Know more about the Jujhar Group, the Ludhiana-based group behind Netplus Broadband.",
  },
  "/contact-us": {
    title: "Contact Netplus Broadband | Get a New Connection",
    description:
      "Contact Netplus Broadband to get a new connection or ask about plans. Find phone numbers, office details and the enquiry form.",
  },
  "/customer-care": {
    title: "Netplus Customer Care | Complaint Resolution Process",
    description:
      "Know how to raise a complaint with Netplus customer care, the steps involved and how to track it.",
  },
  "/faqs": {
    title: "Netplus Broadband FAQs | Plans, Billing & Support",
    description:
      "Answers to common questions about Netplus plans, installation, billing, IPTV and customer support.",
  },
  "/pay-bill": {
    title: "Pay Netplus Bill Online | Netplus Broadband",
    description: "Pay your Netplus Broadband bill online quickly and securely.",
  },
  "/latest-updates": {
    title: "Latest Updates and Customer Notices | Netplus",
    description:
      "Read the latest notices and service updates for Netplus Broadband customers.",
  },
  "/news": {
    title: "Netplus Broadband News and Announcements",
    description:
      "Read news, announcements and press coverage about Netplus Broadband.",
  },
  "/media": {
    title: "Netplus Broadband Media Gallery | Ads and Videos",
    description: "Watch Netplus Broadband ad films and campaign videos.",
  },
  "/download": {
    title: "Downloads | Netplus Broadband Forms and Apps",
    description:
      "Download Netplus Broadband forms, documents and apps in one place.",
  },
  "/pdo-tariff-plan": {
    title: "PDO Tariff Plans | Netplus Public Wi-Fi",
    description:
      "See the Netplus tariff plans for PDO (public data office) partners offering public Wi-Fi.",
  },
  "/pm-wani-wi-fi-launch-event-chandigarh": {
    title: "PM-WANI Wi-Fi Launch Event in Chandigarh | Netplus",
    description:
      "Details of the Netplus PM-WANI public Wi-Fi launch event in Chandigarh.",
  },
  "/voice": {
    title: "Netplus Voice | Smart Voice Telephony",
    description:
      "Get reliable voice calling over your Netplus broadband connection with smart voice telephony.",
  },
  "/leadline-phone": {
    title: "Netplus Bonanza | Leased Line and Phone Offer",
    description:
      "See the Netplus Bonanza offer on leased line and phone connectivity.",
  },
  "/advance-rental-scheme": {
    title: "Advance Rental Scheme | Netplus Broadband",
    description:
      "Learn how the Netplus advance rental scheme works and how to apply.",
  },
  "/enterprise": {
    title: "Enterprise Internet Solutions | Netplus Broadband",
    description:
      "Dependable internet and connectivity solutions for businesses from Netplus Broadband.",
  },
  "/smart-home-automation": {
    title: "Smart Home Automation | Netplus Broadband",
    description:
      "Control lights, appliances and security from one app with Netplus smart home automation.",
  },
  "/smart-city-projects": {
    title: "Smart City Solutions | Netplus Broadband",
    description:
      "Netplus smart city solutions for connected, well-managed cities and municipalities.",
  },
  "/system-intigration-projects": {
    title: "System Integration and Smart Surveillance | Netplus",
    description:
      "Netplus system integration projects including smart surveillance solutions for homes and businesses.",
  },
  "/magic-box": {
    title: "Netplus Magic Box | Better Wi-Fi Coverage at Home",
    description:
      "Extend Wi-Fi coverage across your home or office with the Netplus Magic Box.",
  },
  "/wifi-extender": {
    title: "Netplus Wi-Fi Extender | Wireless Range Booster",
    description:
      "Remove weak Wi-Fi spots with the Netplus wireless Wi-Fi extender.",
  },
  "/dualband-router": {
    title: "Netplus Dual-Band FTTH Router | Wi-Fi at Home",
    description:
      "Get faster, steadier Wi-Fi with the Netplus dual-band FTTH router.",
  },
  "/cloud-storage": {
    title: "Netplus Cloud Storage | Store Files Securely",
    description:
      "Store and access your files and documents securely with Netplus cloud storage.",
  },
  "/hungama": {
    title: "Hungama Music with Netplus | Ad-Free Music",
    description: "Enjoy ad-free music on Hungama with your Netplus connection.",
  },
  "/disclaimer": {
    title: "Disclaimer | Netplus Broadband",
    description:
      "Read the disclaimer for the Netplus Broadband website and services.",
  },
  "/privacy-policy": {
    title: "Privacy Policy | Netplus Broadband",
    description:
      "Read how Netplus Broadband collects, uses and protects your personal data.",
  },
  "/terms-conditions": {
    title: "Terms and Conditions | Netplus Broadband",
    description:
      "Read the terms and conditions for using Netplus Broadband services.",
  },
  "/refund-policy": {
    title: "Refund Policy | Netplus Broadband",
    description:
      "Read the Netplus Broadband refund policy and how refunds are processed.",
  },
};

export default SEO;
